export enum Sounds {
  BOOGIE_PARTY = 'boogie-party',
  MORNING = 'morning',
}
